(function(){
    var sliderEl = document.getElementById('creceSlider');
    if (!sliderEl) return;

    var flkty = null;
    var mq = window.matchMedia('(max-width: 767px)');

    function enableSlider(){
      if (flkty) return;
      flkty = new Flickity(sliderEl, {
        cellSelector: '.crece_card',

        cellAlign: 'left',
        contain: true,
        wrapAround: true,
        draggable: true,
        freeScroll: false,

        prevNextButtons: false,
        pageDots: true,

        setGallerySize: true,

        imagesLoaded: true,

        groupCells: false
      });
    }

    function disableSlider(){
      if (!flkty) return;
      flkty.destroy();
      flkty = null;
    }

    function check(){
      if (mq.matches){
        enableSlider();   
      }else{
        disableSlider();  
      }
    }


    window.addEventListener('load', check);

    if (mq.addEventListener){
      mq.addEventListener('change', check);
    }else{
      mq.addListener(check); // fallback
    }


    window.addEventListener('orientationchange', function(){
      setTimeout(check, 200);
    });
  })();